import { type HelpRibbonControlId } from 'owa-ribbon-ids/lib/helpControlId';

export function focusRibbonButton(paneId: string): void {
    // Map pane types to their corresponding ribbon control IDs
    const paneToRibbonControlMap: Record<string, HelpRibbonControlId> = {
        help: 11201,
        tips: 11210,
        support: 11202,
        feedback: 11203,
        getDiagnostics: 11208,
        rolloutOverrides: 11204,
    };

    // Find the matching ribbon control for this pane
    const matchingPaneType = Object.keys(paneToRibbonControlMap).find(paneType =>
        paneId.includes(paneType)
    );

    if (matchingPaneType) {
        const helpRibbonButtonId = paneToRibbonControlMap[matchingPaneType].toString();
        const helpRibbonButton = document.getElementById(helpRibbonButtonId);
        helpRibbonButton?.focus();
    }
}
